module.exports = __webpack_public_path__ + "static/media/birds.11935686.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/birds.png
// module id = 44
// module chunks = 0